import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Search, Pencil, Trash2 } from "lucide-react";
import { useState } from "react";

interface AccionesGenericasProps<T> {
  data: T;
  id: string | number;
  label?: string;
  queryKey?: ReadonlyArray<unknown>;
  dialogSize?: "sm" | "md" | "lg" | "xl" | "xxl" | string;
  FormularioEdicion?: React.ComponentType<{
    data: T;
    queryKey?: ReadonlyArray<unknown>;
    close: () => void;
  }>;
  onDelete: (id: string | number) => void;
  DetalleContenido?: React.ComponentType<{ data: T }>;
  extraActions?: (props: { data: T; id: string | number }) => React.ReactNode;
}

export function AccionesGenericas<T>({
  data,
  id,
  label = "registro",
  queryKey,
  dialogSize = "xl",
  FormularioEdicion,
  onDelete,
  DetalleContenido,
  extraActions,
}: AccionesGenericasProps<T>) {
  const [modal, setModal] = useState<"editar" | "detalles" | null | undefined>(
    null,
  );

  return (
    <Dialog open={!!modal} onOpenChange={(v) => setModal(v ? modal : null)}>
      <div className="flex gap-2">
        {DetalleContenido && (
          <Button
            size="icon"
            variant="icon"
            onClick={() => setModal("detalles")}
            title="Ver detalles"
          >
            <Search className="h-4 w-4 text-sky-600" />
          </Button>
        )}
        {FormularioEdicion && (
          <Button
            size="icon"
            variant="icon"
            onClick={() => setModal("editar")}
            title="Editar"
          >
            <Pencil className="h-4 w-4 text-amber-500" />
          </Button>
        )}

        <Button
          size="icon"
          variant="icon"
          onClick={() => {
            if (confirm(`¿Deseas eliminar este ${label.toLowerCase()}?`)) {
              onDelete(id);
            }
          }}
          title="Eliminar"
        >
          <Trash2 className="h-4 w-4 text-red-600" />
        </Button>
        {extraActions && extraActions({ data, id })}
      </div>

      <DialogContent size={dialogSize}>
        <DialogHeader>
          <DialogTitle>
            {modal === "editar" ? `Editar ${label}` : `Detalles de ${label}`}
          </DialogTitle>
        </DialogHeader>
        {modal === "editar" && FormularioEdicion && (
          <FormularioEdicion
            data={data}
            queryKey={queryKey}
            close={() => setModal(null)}
          />
        )}
        {modal === "detalles" && DetalleContenido && (
          <DetalleContenido data={data} />
        )}
      </DialogContent>
    </Dialog>
  );
}
